export default __webpack_public_path__ + "static/media/23.db1f6997.jpg";